import SomethingWentWrong from '@/components/pages/plugs/SomethingWentWrong'
import { AppButton } from '@/components/shared/button'

import { CloseButton } from './ui/CloseButton'

type Props = {
  onClose: () => void
}

export const ErrorSlide = ({ onClose }: Props) => (
  <div className="flex h-full w-full flex-col bg-white p-16">
    <div className="flex justify-between">
      <h1 className="text-36 xxs:text-20">Ошибка</h1>{' '}
      <CloseButton onClick={onClose} variant="secondary" />
    </div>
    <SomethingWentWrong withGoToMainButton={false} />
    <AppButton fluid variant="secondary" size="large" onClick={onClose}>
      Понятно
    </AppButton>
  </div>
)
